import { render, staticRenderFns } from "./SearchResponsesItemChat.vue?vue&type=template&id=4975797d&scoped=true"
import script from "./SearchResponsesItemChat.vue?vue&type=script&lang=js"
export * from "./SearchResponsesItemChat.vue?vue&type=script&lang=js"
import style0 from "./SearchResponsesItemChat.vue?vue&type=style&index=0&id=4975797d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4975797d",
  null
  
)

export default component.exports